import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Button, Modal, Tag } from "src/assets/imports/antdComponents";

const modalStyles = {
	header: { height: "4.5rem", padding: "1.25rem 1.5rem", margin: 0 },
	body: { padding: "1.5rem" },
	mask: { backdropFilter: "blur(5px)" },
	footer: { padding: "1rem 1.5rem", margin: 0 },
	content: { padding: 0, margin: 0 },
};

const TagsModal = ({ topTags, activeTag, handleTagClick, isModalVisible, setIsModalVisible, type }) => {
	const { t } = useTranslation();
	const [tempSelectedTags, setTempSelectedTags] = useState(activeTag);

	useEffect(() => {
		setTempSelectedTags(activeTag);
	}, [activeTag]);

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleApply = () => {
		handleTagClick(tempSelectedTags, true);
		setIsModalVisible(false);
	};

	const handleTagSelect = (tag) => {
		setTempSelectedTags(tag);
	};

	return (
		<Modal
			title={t("Select Tag")}
			open={isModalVisible}
			onCancel={handleCancel}
			styles={modalStyles}
			footer={[
				<Button key="cancel" onClick={handleCancel}>
					{t("Cancel")}
				</Button>,
				<Button key="apply" type="primary" onClick={handleApply}>
					{t("Apply")}
				</Button>,
			]}>
			<div className="flex flex-wrap gap-2 justify-start items-center ">
				{topTags?.map((tag, index) => (
					<Tag
						key={`${tag}-${index}`}
						className={`${type === "default" ? "study-tag text-blue-900 mr-3" : "subHeader-tag text-blue-900 mr-3"} ${tempSelectedTags === tag ? "active" : ""}`}
						onClick={() => handleTagSelect(tag)}>
						{tag}
					</Tag>
				))}
			</div>
		</Modal>
	);
};

export default TagsModal;
